function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from './configs';
// Layouts
//import defaultLayout from './layouts/DefaultLayout'
//import simpleLayout from './layouts/SimpleLayout'
//import authLayout from './layouts/AuthLayout'
//import errorLayout from './layouts/ErrorLayout'

import { mapState } from 'vuex';
import scroll_sync_mixin from './apps/data-platform/mixins/scroll_sync_mixin';
export default {
  name: 'AppV2',
  components: {
    //defaultLayout,
    //simpleLayout,
    //authLayout,
    //errorLayout
  },
  data: function data() {
    return {
      //userInfo: window.userInfo,
      menuSmallShow: false,
      isSearchMini: false,
      isUserMenu: false,
      show_more_filter: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['toast'])), {}, {
    isRouterLoaded: function isRouterLoaded() {
      if (this.$route.name !== null) return true;
      return false;
    },
    currentLayout: function currentLayout() {
      var layout = this.$route.meta.layout || 'default';
      return layout + 'Layout';
    },
    isLogin: function isLogin() {
      if (this.$route.name == 'ContLogin') return true;
      return window.userInfo.userRoles ? true : false;
    }
  }),
  head: {
    link: _toConsumableArray(config.icons.map(function (href) {
      return {
        rel: 'stylesheet',
        href: href
      };
    }))
  },
  created: function created() {
    //console.log("created app vue")
  },
  mounted: function mounted() {
    // Attach event listener to the root vue element
    //this.$el.addEventListener('click', this.onClick)
    // Or if you want to affect everything
    // document.addEventListener('click', this.onClick)
  },
  beforeDestroy: function beforeDestroy() {
    //this.$el.removeEventListener('click', this.onClick)
    // document.removeEventListener('click', this.onClick)
  },
  methods: {
    showMiniMenu: function showMiniMenu() {
      //console.log("cambio")
      this.menuSmallShow = !this.menuSmallShow;
      this.isSearchMini = false;
      this.isUserMenu = false;
      this.show_more_filter = false;
    },
    onClick: function onClick(event) {
      if (!event.target.matches('.dropbtn-text')) {
        var dropdowns = document.getElementsByClassName('dropdown-content');
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
  }
};